var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700px",
    height: "700px",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Block-Icons",
    transform: "translate(-2405.000000, -2397.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dashboard",
    transform: "translate(2405.000000, 2397.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#C7DADE",
    cx: 263,
    cy: 259,
    r: 200
  }), /*#__PURE__*/React.createElement("g", {
    id: "Quick-payment",
    transform: "translate(100.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(34.482759, 51.750000)",
    stroke: "#000000",
    strokeWidth: 17.2413793
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.353448,385.822125 C242.965517,392.90325 221.068966,396.75 198.275862,396.75 C88.7672414,396.75 0,307.938375 0,198.375 C0,142.84725 22.8017241,92.641125 59.5517241,56.63175",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.887931,18.811125 C139.491379,6.74475 168.094828,0 198.275862,0 C307.784483,0 396.551724,88.811625 396.551724,198.375 C396.551724,204.076125 396.310345,209.7255 395.836207,215.305875",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.612069,39.4335 C83.8534483,36.2595 88.2327586,33.24075 92.7327586,30.41175",
    id: "Path"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 198.275862,
    cy: 198.375,
    rx: 25.862069,
    ry: 25.875
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.043103,
    y1: 115.566375,
    x2: 216.525862,
    y2: 180.115875,
    id: "Path"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "25.862069 336.375 8.62068966 336.375 8.62068966 353.625 25.862069 353.625"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "17.2413793 370.875 0 370.875 0 388.125 17.2413793 388.125"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "112.068966 465.75 94.8275862 465.75 94.8275862 483 112.068966 483"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "146.551724 457.125 129.310345 457.125 129.310345 474.375 146.551724 474.375"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "43.1034483 439.875 25.862069 439.875 25.862069 457.125 43.1034483 457.125"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "25.862069 405.375 8.62068966 405.375 8.62068966 422.625 25.862069 422.625"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "77.5862069 457.125 60.3448276 457.125 60.3448276 474.375 77.5862069 474.375"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "448.275862 86.25 431.034483 86.25 431.034483 103.5 448.275862 103.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "491.37931 43.125 474.137931 43.125 474.137931 60.375 491.37931 60.375"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "448.275862 0 431.034483 0 431.034483 17.25 448.275862 17.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "482.758621 8.625 465.517241 8.625 465.517241 25.875 482.758621 25.875"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "482.758621 77.625 465.517241 77.625 465.517241 94.875 482.758621 94.875"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "405.172414 43.125 387.931034 43.125 387.931034 60.375 405.172414 60.375"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "413.793103 77.625 396.551724 77.625 396.551724 94.875 413.793103 94.875"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "413.793103 8.625 396.551724 8.625 396.551724 25.875 413.793103 25.875"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 17.2413793,
    cx: 387.931034,
    cy: 370.875,
    rx: 112.068966,
    ry: 112.125
  }), /*#__PURE__*/React.createElement("line", {
    x1: 387.931034,
    y1: 319.125,
    x2: 387.931034,
    y2: 284.625,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 17.2413793
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.206897,388.125 L336.206897,396.75 C336.206897,411.041625 347.784483,422.625 362.068966,422.625 L413.793103,422.625 C428.077586,422.625 439.655172,411.041625 439.655172,396.75 C439.655172,382.458375 428.077586,370.875 413.793103,370.875 L362.068966,370.875 C347.784483,370.875 336.206897,359.291625 336.206897,345 C336.206897,330.708375 347.784483,319.125 362.068966,319.125 L413.793103,319.125 C428.077586,319.125 439.655172,330.708375 439.655172,345 L439.655172,353.625",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 17.2413793
  }), /*#__PURE__*/React.createElement("line", {
    x1: 387.931034,
    y1: 422.625,
    x2: 387.931034,
    y2: 457.125,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 17.2413793
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2068966,250.125 C86.2068966,169.144875 151.818966,103.5 232.758621,103.5 C313.698276,103.5 379.310345,169.144875 379.310345,250.125 C379.310345,253.135125 379.215517,256.128 379.043103,259.095",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 17.2413793
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.0310a99ff3602eb6fe72c3acf59a4b54.svg";
export { ForwardRef as ReactComponent };